import { DateTime } from "luxon";
import { first } from "../utils/lodash";
import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";
import { cDateFormatToLuxon, EPOCH } from "../utils/time";
import { RespondentModel } from "../models/RespondentModel";

export class DateRecalledValue extends RecalledValue {
    time: DateTime;
    respondent: RespondentModel;

    constructor(time: DateTime) {
        super();
        this.time = time;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        switch (property) {
            case "code":
                return this.toCode();
            case "text":
                return this.toText();
            case "year":
                if (this.time == null) return "";
                return this.time.year.toString();
            case "month":
                if (this.time == null) return "";
                return this.time.toFormat("MMMM");
            case "day":
                if (this.time == null) return "";
                return this.time.day.toString();
            case "value":
                if (this.time == null) return "";
                return this.time.toFormat("D");
            case "format":
                if (this.time == null) return "";
                let format: any = parameters;
                while (Array.isArray(format)) format = first(format) || "";
                return this.time.toFormat(cDateFormatToLuxon(format));
            case "answer":
                return this.time.toString();
            default:
                return null;
        }
    }

    toCode(): string {
        if (this.time == null) return "";
        return this.time.diff(EPOCH, "days").toString();
    }

    toText(): string {
        if (this.time == null) return "";
        return this.time.toFormat("DDDD");
    }
}
